module.exports = __webpack_public_path__ + "img/9788937833762.1344a927.jpg";